import { httpRequest } from '~/adapters/httpRequest';
import { host } from '~/config/settings/worktango.settings';
import { urls } from '~/tools/urls';
import { tasksFrom } from '../transformers/task.transformer';

const fetchCompanyActionsList = async (companyId: string) => {
  const queryString = urls.queryStringify({ companyId });
  const url = `${host}/action-planning/actions?${queryString}`;
  const res = await httpRequest<any>(url);

  if (res.error) return Promise.reject(res.error);

  return tasksFrom(res.payload);
};

export const actionsQueries = {
  fetchCompanyActionsList,
};
